import { useKeycloak } from "@react-keycloak/web";

const useAuthenticationHeader = () => {
  const { keycloak } = useKeycloak();
  return {
    name: 'Authorization',
    value: `Bearer ${keycloak.token }`
  };
};

export default useAuthenticationHeader;